import {createAction} from 'redux-actions';
import axios from 'axios';
import {apiUrl} from './config';

export const GET_SERVICE = 'GET_SERVICE'
export const SERVICE_LIST = 'SERVICE_LIST'

export const getService = createAction(GET_SERVICE, (serviceId) => {
  return axios.get(apiUrl + 'client/services/' + serviceId)
    .then(function(res) {
      return res.data.data
    })
});

export const serviceList = createAction(SERVICE_LIST, () => {
  return axios.get(apiUrl + 'client/services')
    .then(function(res) {
      return res.data.data
    })
});
